// extracted by mini-css-extract-plugin
export default {"button":"seeMore_button__IRnj-"};